'use client';

import { useFormatter } from 'next-intl';

type DisplayCurrencyProps = {
  value: number;
  currencyCode: string;
  className?: string;
  fractionDigits?: number;
};

export const DisplayPrice = ({
  value,
  currencyCode,
  className,
  fractionDigits = 2,
}: DisplayCurrencyProps) => {
  const format = useFormatter();

  return (
    <span className={className}>
      {format.number(value, {
        style: 'currency',
        currency: currencyCode,
        maximumFractionDigits: fractionDigits,
        minimumFractionDigits: fractionDigits,
      })}
    </span>
  );
};
